function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );
//requireAll( require.context( './fonts/', true ) );

import $ from 'jquery';
import Swiper from 'swiper';
import Mustache from 'mustache';
import Masonry from 'masonry-layout';
import Headroom from './js/headroom.js';
import imagesLoaded from 'imagesloaded';
import Vimeo from '@vimeo/player';

import 'focus-visible';

window.jQuery = $;
window.$ = $;

$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			scrollPosition: {

				savedScrollPosition: null,

				save: function() {

					PROJECT.common.scrollPosition.savedScrollPosition = document.querySelector('html').scrollTop;
			
					if ( PROJECT.common.scrollPosition.savedScrollPosition === 0 ) {

						PROJECT.common.scrollPosition.savedScrollPosition = document.querySelector('body').scrollTop;

					}

				},
			
				restore: function() {

					if ( PROJECT.common.scrollPosition.savedScrollPosition && PROJECT.common.scrollPosition.savedScrollPosition !== document.querySelector('html').scrollTop ) {

						document.querySelector('html').scrollTop = PROJECT.common.scrollPosition.savedScrollPosition;
						document.querySelector('body').scrollTop = PROJECT.common.scrollPosition.savedScrollPosition;
						PROJECT.common.scrollPosition.savedScrollPosition = null;

					}
				}
			
			},

			init: function () {

				PROJECT.nav.init();

				PROJECT.hero.init();

				PROJECT.carousel.init();

				PROJECT.list.init();

				PROJECT.video.init();
				PROJECT.videos.init();

				PROJECT.image.init();

				PROJECT.share.init();

				PROJECT.timetable.init();

				PROJECT.gform.init();

				PROJECT.photoCarousel.init();

				PROJECT.overlay.init();

				PROJECT.tabs.init();

				PROJECT.countDown.init();

				PROJECT.popup.init();

				$( window ).on( 'resize orientationchange', PROJECT.carousel.init );

			}

		},

		nav: {

			headerSticky: null,

			init: function() {

				$( document ).on( 'click', '.nav__item--has-children > span', {

					class: 'nav__item--has-sub-menu-open',
					classElement: '.nav__item',
					navElement: '> .sub-menu',

				}, PROJECT.nav.toggle );

				$( document ).on( 'click', '.navToggle', {

					class: 'state-role-header--nav-open',
					classElement: 'html',
					navElement: '',
					scrollFix: true

				}, PROJECT.nav.toggle );

				$( document ).on( 'click', '.faqToggle', {

					class: 'view-faq--open',
					classElement: '.faqItem',
					navElement: '.faqText',

				}, PROJECT.nav.toggle );

				PROJECT.nav.sticky();

			},

			toggle: function ( e ) {

				e.preventDefault();

				var parent = $( this ).closest( e.data.classElement );

				if ( !$( parent ).hasClass( e.data.class ) ) {

					if ( typeof e.data.scrollFix !== 'undefined' && e.data.scrollFix === true ) {
						
						PROJECT.nav.headerSticky.freeze();

					}

					$( parent ).addClass( e.data.class );

					if ( e.data.navElement !== '' ) {

						$( parent ).find( e.data.navElement ).slideDown( 250 );

					}

				} else {

					if ( typeof e.data.scrollFix !== 'undefined' && e.data.scrollFix === true ) {
						
						PROJECT.nav.headerSticky.unfreeze();

					}

					$( parent ).removeClass( e.data.class );

					if ( e.data.navElement !== '' ) {

						$( parent ).find( e.data.navElement ).slideUp( 250 );

					}

				}

			},

			sticky: function() {

				var header = document.getElementById( 'header' );

				PROJECT.nav.headerSticky = new Headroom( header, {

					offset : 200,
					tolerance : 0,
					tolerance : {

						up : 5,
						down : 0

					},
					classes : {

						initial : "role-header",
						pinned : "role-header--pinned",
						unpinned : "role-header--unpinned",
						top : "role-header--top",
						notTop : "role-header--not-top",
						bottom : "role-header--bottom",
						notBottom : "role-header--not-bottom"

					}

				});

				PROJECT.nav.headerSticky.init();

			}

		},

		hero: {

			sliderObjects: [],

			init: function() {

				$( '.heroCarousel' ).each( function() {

					var slidesNum = $( this ).find( '.hero__slide' ).length;
					var autoTimeout = 10;

					if ( slidesNum > 1 ) {

						var heroSwiperArgs = {

							speed: 400,
							loop: true,

							slidesPerView: 1,

							pagination: {

								el:	'.heroPager',

								clickable: true,

								bulletClass: 'hero__page',
								bulletActiveClass: 'hero__page--active',
								modifierClass: 'hero__page--'

							},

							navigation: {

								nextEl:	'.heroNext'

							},

							containerModifierClass:	'hero__carousel--',

							slideClass: 'hero__slide',
							slideActiveClass: 'hero__slide--active',
							slideVisibleClass: 'hero__slide--visible',

							wrapperClass: 'hero__slides',

							/* on: {

								slideChange: function() {

									var $slideSection = $( this.el ).parent();

									if ( this.activeIndex > 1 ) {

										if ( !$slideSection.hasClass( 'section-hero--is-slide' ) ) {

											$slideSection.addClass( 'section-hero--is-slide' );

										}

									}

								}

							} */

						};

						if ( $(this).data('carousel-auto') === 'on' ) {

							var thisTimeout = $(this).data('carousel-timeout');

							if ( typeof thisTimeout !== 'undefined' && thisTimeout !== null && parseInt(thisTimeout) > 0 ) {

								autoTimeout = parseInt(thisTimeout);
								
							}

							heroSwiperArgs.autoplay = {
								autoplay: {
									delay: autoTimeout * 1000
								},
								delay: autoTimeout * 1000
							};

						}

						PROJECT.hero.sliderObjects.push( new Swiper( $( this ).get( 0 ), heroSwiperArgs) );

					} else {

						$( this ).find( '.heroNext' ).remove();

					}

				});

			}

		},

		carousel: {

			carouselObject: [],

			init: function() {

				var viewport = PROJECT.common.getViewport();

				$( '.postCarousel' ).each( function() {

					var carouselSlides = $( this ).data( 'slides-md' );

					if ( viewport.width < 768 ) {

						var carouselSlides = $( this ).data( 'slides-xs' );

					} else if ( viewport.width < 992 ) {

						var carouselSlides = $( this ).data( 'slides-sm' );

					}

					var nextEl = $( this ).parent().find( '.postNext' ).get( 0 );
					var prevEl = $( this ).parent().find( '.postPrev' ).get( 0 );

					var postCarousel = new Swiper( $( this ).get( 0 ), {

						speed: 400,

						slidesPerView: carouselSlides,

						navigation: {

							nextEl:	nextEl,
							prevEl:	prevEl,

							disabledClass : 'post-carousel__btn--disabled',

						},

						containerModifierClass:	'post-carousel__carousel--',

						slideClass: 'post-carousel__slide',
						slideActiveClass: 'post-carousel__slide--active',
						slideVisibleClass: 'post-carousel__slide--visible',

						wrapperClass: 'post-carousel__slides'

					});

					PROJECT.carousel.carouselObject.push( postCarousel );

				});

			}

		},

		list: {

			oListForm:			'.tabsListForm',
			oListFilter: 		'.tabs_list_filter',
			oListSearch: 		'.tabs_list_search',
			oListSearchClear: 	'.tabs_list_search_clear',
			oList:				'.tabsList',
			oListSection:		'.tabsListSection',
			oListPager:			'.tabsListPager',
			oListLoader:		'.tabsListLoader',
			oListMasonryList:	'.tabsListMasonry',
			oListMasonry:		{},

			/*
			 * ------------
			 * Init
			 * ------------
			 */

			init: function () {

				$( document ).on( 'change', PROJECT.list.oListFilter, PROJECT.list.bindSelect );
				$( document ).on( 'keyup change', PROJECT.list.oListSearch, PROJECT.list.bindSearch );
				$( document ).on( 'click', PROJECT.list.oListSearchClear, PROJECT.list.bindSearchClear );
				

				$( document ).on( 'submit', PROJECT.list.oListForm, PROJECT.list.bindForm );

				PROJECT.list.initPager();
				PROJECT.list.initMasonry();

				PROJECT.list.bindSelectStyle();

			},

			initPager: function( e ) {

				$( 'a', PROJECT.list.oListPager ).off( 'click' );
				$( 'a', PROJECT.list.oListPager ).on( 'click', PROJECT.list.bindPager );

			},

			getSection: function( element ) {
				
				var section = $( element ).closest( PROJECT.list.oListForm );
				
				return section;

			},

			getSectionKey: function( element ) {

				var key = $( element ).data( 'key' );

				return key;

			},

			initMasonry: function() {

				$( PROJECT.list.oListMasonryList + ' ' + PROJECT.list.oList ).each( function( index, element ) {

					var oListKey = PROJECT.list.getSectionKey( element );

					PROJECT.list.oListMasonry[ oListKey ] = new Masonry( $( element ).get( 0 ), {

						itemSelector	:	'.listItem',
						gutter			:	0,
						columnWidth		:	'.listSpacer',
						percentPosition	: 	true,

					});

					PROJECT.list.reloadMasonry( element );

				});

			},

			reloadMasonry: function( element ) {

				imagesLoaded( $( element ).get( 0 ) ).on( 'progress', function() {

					this.elements.forEach( function( element ) {

						var oListKey = PROJECT.list.getSectionKey( element );

						PROJECT.list.oListMasonry[ oListKey ].layout();

					});

				});

			},



			/*
			 * ------------
			 * Bind User Interaction
			 * ------------
			 */

			bindSelect: function( e ) {

				e.preventDefault();

				var section = PROJECT.list.getSection( this );
				
				PROJECT.list.getListItems( 1, section );

			},

			bindSelectStyle: function() {

				/* if ( !PROJECT.common.isTouch() ) {

					$( PROJECT.list.oListFilter ).each( function() {

						var selectID = $( this ).closest( '.view-list-select' ).parent().attr('id');

						$( this ).select2({

							minimumResultsForSearch		:	'Infinity',
							dropdownAutoWidth			:	'true',
							dropdownParent				:	$( '#' + selectID )

						});

					});

				} */

			},

			bindSearch: function( e ) {
				
				e.preventDefault();
				
				var thisElement = this;

				window.clearTimeout( document.keywordTimeout );

				if ( $( thisElement ).val() !== '' ) {

					$( thisElement ).addClass( 'list-search__input--filled' )

				} else {

					$( thisElement ).removeClass( 'list-search__input--filled' )

				}

				document.keywordTimeout = setTimeout(function () {

					var section = PROJECT.list.getSection( thisElement );
					
					PROJECT.list.getListItems( 1, section );

				}, 700 );

			},

			bindSearchClear: function( e ) {

				e.preventDefault();

				$( this ).parent().find( PROJECT.list.oListSearch ).val( '' ).removeClass( 'list-search__input--filled' ).trigger( 'change' );

			},

			bindForm: function( e ) {

				e.preventDefault();

				var section = PROJECT.list.getSection( this );

				PROJECT.list.getListItems( 1, section );

			},

			bindPager: function( e ) {

				e.preventDefault();

				var pageNo = $( this ).data( 'no' );
				var section = PROJECT.list.getSection( this );

				PROJECT.list.getListItems( pageNo, section );

			},


			/*
			 * ------------
			 * Get Multi Language Lang
			 * ------------
			 */

			getListLang: function( section ) {

				if ( $( section ).find( '[name="tabs_list_lang"]' ).length > 0 ) {

					return $( section ).find( '[name="tabs_list_lang"]' ).val();

				} else {

					return false;

				}

			},


			/*
			 * ------------
			 * The List
			 * ------------
			 */

			getListItems: function ( pageNo, section ) {

				var filters = PROJECT.list.getListFilters( section );
				var search = PROJECT.list.getListSearch( section );
				
				if ( pageNo == 1 ) {

					$( section ).closest( '.section-list' ).addClass( 'section-list--refreshing' );

				} else {

					$( section ).closest( '.section-list' ).addClass( 'section-list--loading' );

				}
				
				var config = {

					ID					:	$( section ).data( 'page' ),
					ID_section			:	$( section ).data( 'section' ),
					cf_list_template	:	$( section ).data( 'template' ),

					_user_filters		:	filters,
					_user_search		:	search,
					_user_page			:	pageNo

				};

				// get language if exist

				var lang = PROJECT.list.getListLang( section );
				
				if ( lang ) {

					config.lang = lang;

				}
				
				$.get(ajax_object.ajaxurl, {

					action	:	'list_load',
					config	:	config

				}, function( data ) {

					data = JSON.parse( data );

					var $data_object = $( data.html );

					if ( pageNo == 1 ) {

						$( section ).find( PROJECT.list.oList ).html( $data_object );

					} else {

						$( section ).find( PROJECT.list.oList ).append( $data_object );

					}

					var oListKey = PROJECT.list.getSectionKey( $( section ).find( PROJECT.list.oList ) );

					var sectionObject = $( section ).closest( PROJECT.list.oListSection );

					if ( $( sectionObject ).hasClass( PROJECT.list.oListMasonryList.substring(1) ) ) {

						PROJECT.list.oListMasonry[ oListKey ].appended( $data_object );

						PROJECT.list.reloadMasonry( $( section ).find( PROJECT.list.oList ) );

					}

					$( section ).find( PROJECT.list.oListPager ).html( data.pager_html );

					PROJECT.list.initPager();

					$( section ).closest( '.section-list' ).removeClass( 'section-list--loading' );
					$( section ).closest( '.section-list' ).removeClass( 'section-list--refreshing' );

				});

			},

			getListFilters: function ( section ) {

				var filters = [];

				if ( $( section ).find( PROJECT.list.oListFilter ).length > 0 ) {

					$( section ).find( PROJECT.list.oListFilter ).each( function( i, v ) {

						var filterValue = $( this ).val();
						var filterType	= $( this ).data( 'filter-type' );
						var filterTax	= $( this ).data( 'filter-tax' );

						var filter = {

							value	:	filterValue,
							type	:	filterType,
							tax		:	filterTax,

						};

						filters.push( filter );

					});

				}

				return filters;

			},

			getListSearch: function() {

				var keyword = '';

				if ( $( PROJECT.list.oListSearch ).length > 0 ) {

					keyword = $( PROJECT.list.oListSearch ).val();

				}

				return keyword;

			},

			updateListPager: function( no ) {



			}

		},

		// this is the section-video module for vimeo background video

		video: {

			objects: [],

			init: function () {

				$( document ).on( 'click', '.jsVideoPlay', PROJECT.video.stopPlay );
				$( document ).on( 'click', '.jsVideoSound', PROJECT.video.muteUnmute );

				var $vimeos = $( '[data-vimeo]' );

				if ( $vimeos.length > 0 ) {

					$vimeos.each( function( index ) {

						var vimeoID = $( this ).data( 'vimeo' );

						if ( vimeoID ) {

							PROJECT.video.initVimeo( vimeoID );

						}
						
					});

				}

			},

			initVimeo : function ( id ) {

				var vimeoConfig = {
					
					id: id,
					width: "100%",
					height: "100%",
					loop: true,
					autoplay: true,
					background: true,
					muted: true,
					responsive: true

				};

				//init vimeo
				
				var vimeo = new Vimeo( 'player-' + id , vimeoConfig );


				// add to array and add ID to element as reference

				var objectID = PROJECT.video.objects.push( vimeo );

				var $parent = PROJECT.video.getParent( vimeo.element );
				
				$parent.data( 'object', objectID );

			
				// callback for timeupdate

				vimeo.on( 'timeupdate', PROJECT.video.updateTime );

			},

			updateTime: function( data ) {
				
				var $parent = PROJECT.video.getParent( this.element );
				
				$parent.find( '.jsVideoTimeBar' ).css( "width", data.percent * 100 + "%" );

				/* var time = data.seconds;
				var minutes = ("0" + Math.floor(time / 60)).slice(-2);
				var seconds = ("0" + Math.floor(time % 60)).slice(-2);
			
				$parent.find( '.jsVideoTime' ).text( minutes + ":" + seconds ); */

			},

			stopPlay: function( e ) {

				e.preventDefault();

				var $parent = PROJECT.video.getParent( this );

				var vimeoObject = PROJECT.video.getObject( $parent );
				
				vimeoObject.getPaused().then( function( paused ) {
					
					if ( paused ) {

						$parent.removeClass( 'section-video--paused' );

						vimeoObject.play();

					} else {

						$parent.addClass( 'section-video--paused' );

						vimeoObject.pause();

					}

				});

			},

			muteUnmute: function( e ) {

				e.preventDefault();

				var $parent = PROJECT.video.getParent( this );

				var vimeoObject = PROJECT.video.getObject( $parent );
				
				vimeoObject.getMuted().then( function( muted ) {
					
					if ( muted ) {

						$parent.addClass( 'section-video--unmuted' );

						vimeoObject.setMuted( false );

					} else {

						$parent.removeClass( 'section-video--unmuted' );

						vimeoObject.setMuted( true );

					}

				});

			},

			getParent: function( e ) {

				var parent = $( e ).closest( '.jsVideo' );

				return parent;

			},

			getObject: function( $parent ) {

				var objectID = $parent.data( 'object' );

				return PROJECT.video.objects[ (objectID - 1 ) ];

			}

		},

		// this is for th e video overlays

		videos: {
			
			prevPushURL: '',

			init: function () {

				$( document ).on( 'click', '.videoOpen', PROJECT.videos.openPopup );
				$( document ).on( 'click', PROJECT.videos.closePopup );

				PROJECT.videos.makeResponsive();

			},

			makeResponsive: function() {

				$( '.videoResponsive' ).each( function() {

					var $iframe = $( this ).find( 'iframe' ),
						width = $iframe.width(),
						height = $iframe.height(),
						ratio = height / width;

					$( this ).css({

						paddingTop : ( ratio * 100 ) + '%'

					});

					$iframe.css({

						width:	'100%',
						height:	'100%'

					})

				});

			},

			openPopup: function( e ) {

				e.preventDefault();

				var videoIframeHTML = $( this ).data( 'video' ),
					videoTemplate = $( this ).data( 'template' ),
					videoPushURL = $( this ).data( 'push-url' ),
					videoShare = $( this ).data( 'share' );

				$.get( videoTemplate, function( template ) {

					PROJECT.videos.prevPushURL = window.location.href;
					
					var videoTemplateRendered = Mustache.render( template, {

						iframe: videoIframeHTML,
						share: videoShare

					} );

					$( 'body' ).append( videoTemplateRendered ).hide().fadeIn( 300 );

					PROJECT.videos.makeResponsive();

					if ( videoPushURL !== undefined && videoPushURL !== '' ) {

						history.pushState( {}, '', videoPushURL );

					}

				});

			},

			closePopup: function( e ) {

				$( '.videoPopup' ).fadeOut( 300, function() {

					$( this ).remove();

					if ( PROJECT.videos.prevPushURL != '' ) {

						history.pushState( {}, '', PROJECT.videos.prevPushURL );

						PROJECT.videos.prevPushURL = '';

					}

				});

			}

		},

		image: {
			
			object: '.imageOpen',

			init: function () {

				$( document ).on( 'click', PROJECT.image.object, PROJECT.image.openPopup );
				$( document ).on( 'click', PROJECT.image.closePopup );

			},

			openPopup: function( e ) {

				e.preventDefault();

				var imageTemplateDir = $( this ).data( 'template' ),
					imageCurrent = $( this ).attr( 'href' ),
					imageinitialSlide = 0;

				var photoTemplate = imageTemplateDir + '/atoms/atom-photo.mst';

				$.get( photoTemplate, function( photoTemplate ) {
					
					var photos = [];

					$( PROJECT.image.object ).each( function( i ) {

						var photoImageURL = $( this ).attr( 'href' );

						var photo = {
							
							classes		:	' atom-photo--no-bg atom-photo--fit',
							image 		:	photoImageURL,
							alt 		:	$( this ).data( 'alt' ),
							description	:	$( this ).data( 'description' ),
							caption		:	$( this ).data( 'caption' ),
							focus 		:	false,
							thumb 		:	true
	
						};

						if ( imageCurrent == photoImageURL ) {

							imageinitialSlide = i;

						}

						var photoHtml = {};
							photoHtml.photo = Mustache.render( photoTemplate, photo );
	
						photos.push( photoHtml );
	
					});

					if ( photos.length > 0 ) {

						var carouselTemplate = imageTemplateDir + '/views/view-photo-carousel.mst';
						
						$.get( carouselTemplate, function( carouselTemplate ) {
	
							var carouselHtml = Mustache.render( carouselTemplate, {
								
								classes	: ' view-photo-carousel--popup',
								count 	: photos.length,
								photos	: photos
	
							} );

							var lightboxTemplate = imageTemplateDir + '/views/view-image-popup.mst';

							$.get( lightboxTemplate, function( lightboxTemplate ) {

								var lightboxHtml = Mustache.render( lightboxTemplate, {
			
									html	: carouselHtml
			
								} );
			
								$( 'body' ).append( lightboxHtml ).hide().fadeIn( 300 );

								PROJECT.photoCarousel.init( imageinitialSlide );
			
							});
	
						});
	
					}

				});

			},

			closePopup: function( e ) {
				
				var imagePopupBox = $( '.imagePopupWrapper' );
				
				if ( !imagePopupBox.is(e.target) && imagePopupBox.has(e.target).length === 0 ) {

					$( '.imagePopup' ).fadeOut( 300, function() {

						$( this ).remove();

					});

				}

			}

		},

		share: {

			init: function () {

				$( document ).on( 'click', '.socialShareBtn', PROJECT.share.openSocial );

			},

			openSocial: function( e ) {

				e.preventDefault();

				var networkShareUrl = $( this ).attr( 'href' );

				PROJECT.share.popupwindow( networkShareUrl, '', 500, 300);

			},

			popupwindow: function(url, title, w, h) {

				var screen = PROJECT.common.getViewport();

				var left = (screen.width/2)-(w/2);
				var top = (screen.height/2)-(h/2);

				return window.open( url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left );

			},

		},

		timetable: {

			init: function () {

				// toggle open/close

				$( document ).on( 'click', '.timetableFilterToggle', {

					class: 'section-timetable--filters-open',
					classElement: '.timetableSection',
					navElement: '.timetableFilters',

				}, PROJECT.nav.toggle );

				$( document ).on( 'click', '.timetableEventToggle', {

					class: 'view-card-event--open',
					classElement: '.timetableEventCard',
					navElement: '.timetableEventExcerpt',

				}, PROJECT.nav.toggle );

				$( document ).on( 'click', '.timetableDayToggle', {

					class: 'timetable__table-day--open',
					classElement: '.timetableDay',
					navElement: '.timetableDayEvents',

				}, PROJECT.nav.toggle );

				// filters

				$( document ).on( 'change', '.timetableFilter input', PROJECT.timetable.filter );
				$( document ).on( 'change', '.timetableFilter select', PROJECT.timetable.filter );

			},

			filter: function () {

				var filters = '';

				// get AND filters

				var filterValues = [];

				var $parent = PROJECT.timetable.parent( $( this ) );

				var $filtersAnd = $parent.find( '.timetableFilterAND select' );

				$filtersAnd.each( function() {

					var filterValue = $( this ).val();

					if ( filterValue != '' ) {

						filterValues.push( filterValue );

					}

				});

				// get OR filters

				var $filtersOr = $parent.find( '.timetableFilterOR input' );

				$filtersOr.each( function() {

					if ( $( this ).is( ':checked' ) ) {

						if ( filters != '' ) {

							filters += ', ';

						}

						filters += '.' + $( this ).val();

						filterValues.forEach( function( filterValue ) {

							filters += '.' + filterValue;

						});

					}

				});

				// slide up everything that we do not want to show (if needed)

				$parent
					.find( '.timetableFilterItem' )
					.not( filters )
					.addClass( 'timetable__table-event--hidden' )
					.slideUp( 200 );


				// slide down everything we need to show (if needed)

				$parent
					.find( filters )
					.removeClass( 'timetable__table-event--hidden' )
					.slideDown( 200);


				// check, after removing events, the day still has events to show
				// if yes, slide down
				// if no, slide up

				$parent.find( '.timetableDay' ).each( function() {

					var $eventsElement = $( this ).find( '.timetableDayEvents' );

					if ( $eventsElement.children().not( '.timetable__table-event--hidden' ).length == 0 ) {

						$( this ).slideUp( 200, PROJECT.timetable.showNoResults );

					} else {

						$( this ).slideDown( 200, PROJECT.timetable.showNoResults );

					}

				});

			},

			parent: function( $this ) {

				var $parent = $this.closest( '.timetableSection' );

				return $parent;

			},

			showNoResults: function() {

				var $parent = PROJECT.timetable.parent( $( this ) );

				if ( $parent.find( '.timetableDay:visible' ).length == 0 ) {

					$parent.find( '.timetableNoResults' ).slideDown( 200 );

				} else {

					$parent.find( '.timetableNoResults' ).slideUp( 200 );

				}

			}

		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );
				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );

				$( document ).on( 'submit', '.gform_wrapper form', PROJECT.gform.showLoader );

			},

			hideLoader: function( event, form_id, current_page ) {

				var $container = PROJECT.gform.getFormContainer( $( '#gform_' + form_id ) );

				$container.find( '.gformLoader' ).fadeOut( 200 );

			},

			showLoader: function() {

				var $container = PROJECT.gform.getFormContainer( $( this ) );

				$container.find( '.gformLoader' ).fadeIn( 200 );

			},

			getFormContainer: function( $element ) {

				var $container = $element.closest( '.gformContainer' );

				return $container;

			}

		},

		photoCarousel: {

			init: function( initialSlide = 0 ) {
				
				$( '.photoCarousel' ).each( function() {

					var $carouselThumbs = $( this ).find( '.photoThumbs' );
					var thumbsTotal = $carouselThumbs.find( '.photoThumb' ).length;

					if ( thumbsTotal > 0 ) {

						if ( thumbsTotal > 4 ) {

							thumbsTotal = 4;

						}

						var carouselThumbs = new Swiper( $carouselThumbs.get( 0 ), {

							spaceBetween: 10,
							slidesPerView: thumbsTotal,
							loopedSlides: 5,
							watchSlidesVisibility: true,
							watchSlidesProgress: true,

						});

					}

					var $carouselLarge = $( this ).find( '.photoLarge' );

					var carouselArgs = {

						loopedSlides: 5,

						initialSlide : initialSlide,

						navigation: {

							nextEl: '.photoCarouselNext',
							prevEl: '.photoCarouselPrev',

							disabledClass: 'photo-carousel__btn--disabled'

						}

					};

					if ( thumbsTotal > 0 ) {

						carouselArgs.thumbs = {

							swiper: carouselThumbs,

							slideThumbActiveClass: 'photo-carousel__thumb--active',

						};

					}

					var carouselLarge = new Swiper( $carouselLarge.get( 0 ), carouselArgs );

				});

			}

		},

		overlay: {

			state: 'closed',
			overlay: '',
			player: '',
			type: '',

			init: function() {

				$( document ).on( 'keyup', PROJECT.overlay.close );

				$( document ).on( 'click', 'a[href*="\\#"]:not([href="#"])', PROJECT.overlay.toggle );

				$( document ).on( 'click', '.jsOverlayToggle', PROJECT.overlay.toggle );

				var id = PROJECT.cookies.getCookie( 'player' );

				if ( id ) {

					PROJECT.overlay.toggle();
				}
			},

			close: function( e ) {

				if ( e.keyCode == 27 ) {

					if ( PROJECT.overlay.state == 'open'  ) {

						PROJECT.overlay.state = 'closed';

						PROJECT.overlay.overlay.removeClass( 'state--overlay-open' );

						PROJECT.overlay.stop();

					}

				}

			},

			toggle: function( e ) {

				if ( e ) {

					e.preventDefault();

				}


				var cookie_id = PROJECT.cookies.getCookie( 'player' );

				var timeout = cookie_id ? 0 : 3000;

				var id = cookie_id ? cookie_id : $(this).attr('href');

				if ( PROJECT.overlay.state == 'closed'  ) {

					if ( $( id ).length ) {

						PROJECT.overlay.overlay = $( id );

						PROJECT.overlay.type =  $( id ).data( 'stream-type' );

						PROJECT.overlay.player = $( id ).find( PROJECT.overlay.type );

						PROJECT.overlay.state = 'open';

						PROJECT.overlay.overlay.addClass( 'state--overlay-open' );

						if ( PROJECT.overlay.player ) {

							PROJECT.overlay.play( id );


						}


						if ( $( id ).hasClass( 'jsOverlaySmall' ) ) {

							$( id ).removeClass( 'state--overlay-small' );

							setTimeout(

								function() {

									$( id ).addClass( 'state--overlay-small' );
								},

								timeout
							);

						}

					}

				} else {

					if ( PROJECT.overlay.player ) {

						PROJECT.overlay.stop( id );

					}

					PROJECT.overlay.state = 'closed';

					PROJECT.overlay.overlay.removeClass( 'state--overlay-open' );

				}

			},

			play: function( id ) {

				if ( PROJECT.overlay.type == 'iframe' ) {

					var iframe = PROJECT.overlay.player[0];

						iframe.src =
							iframe.src.indexOf('autoplay=1') != -1 ?
							iframe.src.replace('autoplay=1','') : iframe.src.concat('&autoplay=1');

				} else if ( PROJECT.overlay.type == 'audio' ) {

					PROJECT.overlay.player[0].play();

					PROJECT.cookies.setCookie( 'player', id, 7 );

				}

			},

			stop: function() {

				if ( PROJECT.overlay.type == 'iframe' ) {

					var iframe = PROJECT.overlay.player[0];

					iframe.src = iframe.src.replace('autoplay=1','');

				} else if ( PROJECT.overlay.type == 'audio' ) {

					PROJECT.overlay.player[0].pause();

					PROJECT.cookies.setCookie( 'player', null, 7 );
				}
			}

		},

		cookies: {

			setCookie: function (name,value,days) {

				var expires = "";
				if (days) {
					var date = new Date();
					date.setTime(date.getTime() + (days*24*60*60*1000));
					expires = "; expires=" + date.toUTCString();
				}
				document.cookie = name + "=" + (value || "")  + expires + "; path=/";
			},

			getCookie: function (name) {

				var nameEQ = name + "=";
				var ca = document.cookie.split(';');
				for(var i=0;i < ca.length;i++) {
					var c = ca[i];
					while (c.charAt(0)==' ') c = c.substring(1,c.length);
					if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
				}
				return null;
			},

			eraseCookie: function (name) {

				document.cookie = name+'=; Max-Age=-99999999;';
			
			}

		},

		tabs: {

			section: '.jsTabs',

			init: function() {

				$( document ).on( 'click', '[data-tab]', PROJECT.tabs.switch );

			},

			switch: function( e ) {

				e.preventDefault();

				var $this = $( this );
				var $parent = PROJECT.tabs.getParent( $( this ) );

				var tabIndex = $( this ).data( 'tab' )

				$parent.find( '[data-tab]' ).removeClass( 'tabs__tab--active' );
				
				$this.addClass( 'tabs__tab--active' );

				$( '.jsTabsContent' ).slideUp( 200, function() {

					$( '[data-tab-content]' ).hide();
					$( '[data-tab-content="' + tabIndex + '"]' ).show();

					$( this ).delay( 100 ).slideDown( 200 );
					
				})

			},

			getParent: function( $el ) {

				return $el.closest( PROJECT.tabs.section );

			}

		},

		countDown: {

			counter: null,

			init: function() {

				$( '.jsCountdown' ).each( function() {

					var countTo = $( this ).data( 'countdate' );
						countTo = new Date( countTo ).getTime();

					var $countObject = $( this );
					
					PROJECT.countDown.count( countTo, $countObject );

					PROJECT.countDown.counter = setInterval(function() {

						PROJECT.countDown.count( countTo, $countObject );

					}, 1000 );

				});

			},

			count: function( countTo, $countObject ) {

				var countFrom = new Date().getTime(),
					countDistance = countTo - countFrom;

				if ( countDistance < 0 ) {

					$countObject.remove();
					
					clearInterval( PROJECT.countDown.counter );

				}

				var days = Math.floor( countDistance / ( 1000 * 60 * 60 * 24 ) );
					days = ( days < 10 ) ? ( "0" + days ) : days;

				var hours = Math.floor( ( countDistance % ( 1000 * 60 * 60 * 24 ) ) / (1000 * 60 * 60 ) );
					hours = ( hours < 10 ) ? ( "0" + hours ) : hours;

				var minutes = Math.floor( ( countDistance % ( 1000 * 60 * 60 ) ) / ( 1000 * 60 ) );
					minutes = ( minutes < 10 ) ? ( "0" + minutes ) : minutes;

				var seconds = Math.floor( ( countDistance % ( 1000 * 60 ) ) / 1000 );
					seconds = ( seconds < 10 ) ? ( "0" + seconds ) : seconds;
				
				

				$countObject.find( '.jsCountdownDays' ).text( days );
				$countObject.find( '.jsCountdownHours' ).text( hours );
				$countObject.find( '.jsCountdownMin' ).text( minutes );
				$countObject.find( '.jsCountdownSec' ).text( seconds );

			}

		},

		popup: {

			init: function() {

				$( document ).on( 'click', 'a[href="#open_popup_radio"]', function(e) {
					
					e.preventDefault();
					
					window.open(tabs_globals.stream_page, "", "width=350,height=800,left=0");

				} );

			}

		}

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});

